var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grafici_icona",
    "data-name": "grafici icona",
    transform: "translate(-16 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_885",
    "data-name": "Tracciato 885",
    d: "M31.467,32h-14.4A1.067,1.067,0,0,1,16,30.933v-14.4a.533.533,0,1,1,1.067,0v14.4h14.4a.533.533,0,1,1,0,1.067Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_886",
    "data-name": "Tracciato 886",
    d: "M82.036,215.467H80.964a1.1,1.1,0,0,1-.964-1.2V209.2a1.1,1.1,0,0,1,.964-1.2h1.071A1.1,1.1,0,0,1,83,209.2v5.067A1.1,1.1,0,0,1,82.036,215.467Z",
    transform: "translate(-61.867 -185.6)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_887",
    "data-name": "Tracciato 887",
    d: "M226.036,169.067h-1.071a1.1,1.1,0,0,1-.964-1.2V161.2a1.1,1.1,0,0,1,.964-1.2h1.071a1.1,1.1,0,0,1,.964,1.2v6.667A1.1,1.1,0,0,1,226.036,169.067Z",
    transform: "translate(-201.067 -139.2)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_888",
    "data-name": "Tracciato 888",
    d: "M369.676,107.2H368.6a1.1,1.1,0,0,1-.964-1.2V97.2A1.1,1.1,0,0,1,368.6,96h1.071a1.1,1.1,0,0,1,.964,1.2V106A1.1,1.1,0,0,1,369.676,107.2Z",
    transform: "translate(-339.919 -77.333)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.b573cad2ca1b86fd9d1d3f3947427cfb.svg";
export { ForwardRef as ReactComponent };